<template>
    <v-dialog
      v-model="isOpen"
      persistent
      max-width="500"
    >
      <v-card >
        <v-card-title class="headline">
          {{$t('correct_data')}}
        </v-card-title>
        <v-card-text>
          <v-text-field
            :label="$t('loan_sum')"
            :error-messages="errors.collect('sum')"
            outlined
            v-model="application.sum"
            data-vv-name="sum"
            v-validate="{ required: true, min_value: 0, max_value: 100000}"
            required>
          </v-text-field>

          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="application.maturity_date"
                :label="$t('maturity_date')"
                readonly
                v-on="on"
                outlined
              ></v-text-field>
            </template>
            <v-date-picker v-model="application.maturity_date" :allowed-dates="allowedDates" @input="menu = false" no-title scrollable>
            </v-date-picker>
          </v-menu>

          <v-text-field
            :label="$t('percentage_rate')"
            :error-messages="errors.collect('bet')"
            outlined
            type="number"
            v-model="application.bet"
            placeholder="0.5"
            min="0.00"
            step="0.01"
            max="100.00"
            data-vv-name="bet"
            v-validate="{ required: true, min_value: 0.00, max_value: 100.00, decimal: 2}"
            required>
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="close()">{{$t('close')}}</v-btn>
          <v-btn color="primary" @click="save()">{{$t('save')}}</v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
</template>

<script>
import TimePicker from "@/app/shared/components/form-inputs/TimePicker";
import moment from 'moment';
export default {
  $_veeValidate: {
      validator: 'new',
  },
  components: {
      TimePicker,
  },
  name: 'ChangeApplicationData',
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    isOpen() {
      return this.$store.getters.IS_APPLICATION_MODAL_OPENED;
    },
    application() {
      return this.$store.getters.GET_APPLICATION_FOR_MODAL;
    }
  },
  methods: {
    save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let start = moment(this.application.payout_date);
          let end = moment(this.application.maturity_date);
          let days = moment.duration(end.diff(start)).asDays();
          this.$store.dispatch('CHANGE_APPLICATION', {
            id: this.application.id,
            days: days,
            bet: this.application.bet,
            sum: parseInt(this.application.sum),
          });
          this.$toast.success(this.$t('settings_saved'));
          this.close();
        }
      })
    },
    close() {
      this.$store.dispatch('OPEN_APPLICATION_MODAL', false);
    },
    allowedDates(val) {
      let start = moment(this.application.payout_date);
      let end = moment(val);
      return moment.duration(end.diff(start)).asDays() > 0;
    }
  },
};
</script>
